export const account = {
  getCustomer: (customerId: string) => `/IPP/accounts/customer/${customerId}`,
  getAccountDetails: (accountCode: string) => `/IPP/accounts/details/${accountCode}`,
  getCreditLimit: (accountId: string) => `/IPP/accounts/credit-limit/${accountId}`,
  postCreditLimit: () => '/IPP/accounts/credit-limit',
  getCreditLimitRequests: (accountId: string) => `/IPP/accounts/credit-limit/${accountId}/request`,
  approveCreditLimitRequest: (requestId: string) => `/IPP/accounts/credit-limit/approve/${requestId}`,
  rejectCreditLimitRequest: (requestId: string) => `/IPP/accounts/credit-limit/reject/${requestId}`,
  getCreditLimitFile: (requestId: string) => `/IPP/accounts/credit-limit/file/${requestId}`,
  uploadCreditLimitFile: (requestId: string) => `/IPP/accounts/credit-form/file${requestId}`,
  partnerAccountNumber: () => '/IPP/accounts/partner-account',
  getCreditPdf: () => '/credit/pdf',
};

export const application = {
  getApplications: () => '/IPP/search/applications',
  getApplication: () => '/IPP/search/applications',
  getSupplementApplication: (applicationId: string) => `/IPP/applications/supplementary/${applicationId}`,
  getMainApplication: (applicationId: string) => `/IPP/applications/main/${applicationId}`,
  getManualApplication: () => '/IPP/search/manual/applications',
  pdf: () => '/IPP/applications/pdf',
  saveSupplement: () => '/IPP/applications/supplementary',
  saveApplication: () => '/IPP/applications',
  approveCreditLimit: (applicationId: string) => `/IPP/applications/approveCreditLimit/${applicationId}`,
  rejectCreditLimit: (applicationId: string) => `/IPP/applications/rejectCreditLimit/${applicationId}`,
  submitApplication: (applicationId: string) => `/IPP/applications/submit/${applicationId}`,
  rejectApplication: (applicationId: string) => `/IPP/applications/reject/${applicationId}`,
  assignApplication: (applicationId: string) => `/IPP/applications/assign/${applicationId}`,
  assignManualApplication: () => `/IPP/manual-applications/assign`,
  rejectManualApplicationFile: (fileId: string) => `/IPP/manual-applications/file/reject/${fileId}`,
  submitManualApplication: () => '/IPP/manual-applications/submit',
  completeManualApplication: () => '/IPP/manual-applications/complete',
  rejectManualApplication: () => '/IPP/manual-applications/reject',
};

export const auth = {
  authenticate: (userId: string) => `/auth/token/${userId}/IPP`,
  refreshToken: (refreshToken: string) => `/auth/refresh/${refreshToken}/IPP`,
  onbehalf: (userId: string) => `/auth/onbehalf/${userId}`,
};

export const card = {
  getAccount: (accountId: string) => `/IPP/cards/account/${accountId}`,
  activation: (cardId: string) => `/IPP/cards/activation/${cardId}`,
  replaceCard: (cardId: string) => `/IPP/cards/replace/${cardId}`,
  reprintPin: (cardId: string) => `/IPP/cards/reprint-pin/${cardId}`,
  blockCard: (cardId: string) => `/IPP/cards/block/${cardId}`,
  unblockCard: (cardId: string) => `/IPP/cards/unblock/${cardId}`,
};

export const customer = {
  getCustomers: () => '/IPP/search/customers',
  getCustomerCard: (customerId: string) => `/IPP/customers/${customerId}`,
};

export const dictionaries = {
  getCountries: () => '/IPP/dictionaries/countries',
  getNationalities: () => '/IPP/dictionaries/nationalities',
  getEconomicActivities: () => '/IPP/dictionaries/economic-activities',
};

export const file = {
  getTypes: () => '/IPP/files/types',
  getApplicationFiles: (applicationId: string) => `/IPP/files/application/${applicationId}`,
  downloadFile: (fileId: string) => `/IPP/files/download/${fileId}`,
  uploadFile: () => '/IPP/files',
  deleteFile: (fileId: string) => `/IPP/files/${fileId}`,
};

export const messages = {
  getThreads: () => '/IPP/messages/threads',
  getThread: (threadId: string) => `/IPP/messages/threads/${threadId}`,
  postMessage: () => '/IPP/messages',
  readMessage: () => '/IPP/messages/read',
  deleteMessage: (groupId: string) => `/IPP/messages/${groupId}`,
  postAttachment: (messageId: string) => `/IPP/messages/${messageId}/attachments`,
  downloadAttachment: (messageId: string, fileId: string) => `/IPP/messages/${messageId}/attachments/${fileId}`,
};

export const product = {
  getPartners: () => '/IPP/products/partners',
  getProducts: () => '/IPP/products',
};

export const resources = {
  getRepository: () => '/IPP/resources/repository',
  download: (id: string) => `/IPP/resources/download/${id}`,
};

export const statements = {
  getStatements: () => '/IPP/statements/search',
  downloadStatement: () => '/IPP/statements/download',
};

export const transaction = {
  getTransactions: () => '/IPP/transactions',
};

export const users = {
  getUsers: () => '/IPP/users',
};
